module.exports = __webpack_public_path__ + "img/thumbnail_Wolverine_m_normal.d8b1eee9.png";